export default {
      id: "ic_comment_green-usage",
      viewBox: "0 0 22 18",
      url: "/" + "images/icons.3.109.2.svg#ic_comment_green-usage",
      toString: function () {
        return this.url;
      }
    }